import React from 'react';
import Router from 'next/router';
import Script from 'next/script';

declare global {
  /* eslint-disable no-unused-vars */
  interface Window {
    analytics: any;
    FrontChat: any;
  }
}

interface PageProps {
  children: React.ReactNode;
}

// Track client-side page views with Segment
Router.events.on('routeChangeComplete', () => {
  window.analytics.page('public ', window.location.pathname);
});

export const Page = ({ children }: PageProps) => (
  <>
    {children}
    <Script id="segment-script" strategy="afterInteractive">
      {`
       if (!navigator.userAgent.includes('headless')) {
        !(function () {
          var analytics = (window.analytics = window.analytics || []);
          if (!analytics.initialize)
            if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.');
            else {
              analytics.invoked = !0;
              analytics.methods = [
                'trackSubmit',
                'trackClick',
                'trackLink',
                'trackForm',
                'pageview',
                'identify',
                'reset',
                'group',
                'track',
                'ready',
                'alias',
                'debug',
                'page',
                'once',
                'off',
                'on',
                'addSourceMiddleware',
                'addIntegrationMiddleware',
                'setAnonymousId',
                'addDestinationMiddleware',
              ];
              analytics.factory = function (e) {
                return function () {
                  var t = Array.prototype.slice.call(arguments);
                  t.unshift(e);
                  analytics.push(t);
                  return analytics;
                };
              };
              for (var e = 0; e < analytics.methods.length; e++) {
                var key = analytics.methods[e];
                analytics[key] = analytics.factory(key);
              }
              analytics.load = function (key, e) {
                var t = document.createElement('script');
                t.type = 'text/javascript';
                t.async = !0;
                t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
                var n = document.getElementsByTagName('script')[0];
                n.parentNode.insertBefore(t, n);
                analytics._loadOptions = e;
              };
              analytics.SNIPPET_VERSION = '4.13.1';
              analytics.load('${process.env.NEXT_PUBLIC_SEGMENT_ID}');
            }
        })();
        analytics.page('public ', window.location.pathname);
        }`}
    </Script>
    <Script id="auto-pilot" strategy="afterInteractive">
      {` 
      if (!navigator.userAgent.includes('headless')) {
        (function (o) {
          var b = 'https://quickkoala.io/anywhere/',
            t = '3ee446e16fa142e0a849c2c68bfe31947d9594daf2d6496381eac1257f11785b',
            a = (window.AutopilotAnywhere = {
              _runQueue: [],
              run: function () {
                this._runQueue.push(arguments);
              },
            }),
            c = encodeURIComponent,
            s = 'SCRIPT',
            d = document,
            l = d.getElementsByTagName(s)[0],
            p = 't=' + c(d.title || '') + '&u=' + c(d.location.href || '') + '&r=' + c(d.referrer || ''),
            j = 'text/javascript',
            z,
            y;
          if (!window.Autopilot) window.Autopilot = a;
          if (o.app) p = 'devmode=true&' + p;
          z = function (src, asy) {
            var e = d.createElement(s);
            e.src = src;
            e.type = j;
            e.async = asy;
            l.parentNode.insertBefore(e, l);
          };
          y = function () {
            z(b + t + '?' + p, true);
          };
          if (window.attachEvent) {
            window.attachEvent('onload', y);
          } else {
            window.addEventListener('load', y, false);
          }
        })({});
      }
   `}
    </Script>
    <Script
      id="front-assets"
      src="https://chat-assets.frontapp.com/v1/chat.bundle.js"
      strategy="afterInteractive"
      onLoad={() => {
        window.FrontChat('init', { chatId: `${process.env.NEXT_PUBLIC_FRONT_CHAT_ID}`, useDefaultLauncher: true });
      }}
    />
  </>
);
